import { render, staticRenderFns } from "./location_component.vue?vue&type=template&id=1893955e&"
import script from "./location_component.vue?vue&type=script&lang=js&"
export * from "./location_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports